import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    user_id: null,
    serviceType: "",
    servicePackage: "",
    bike_id: "",
    bikeType: "",
    gearSystem: "",
    bikeName: "",
    bikeBrand: "",
    bikeModel: "",
    bikeWeight: "",
    bikeMileage: "",
    mobile: "",
    name: "",
    city: "",
    addressName: "",
    state: "",
    pincode: "",
    address_type: "",
    full_address: "",
    address_id: "",
    frame_number: "",
    branch: "",
    serviceRequired: "",
    date_time: "",
    offer: "",
    amount: "",
    member_on: "",
    slotDate:"",
    slotTime:"",
    packageType:"",
    selectedAddress:"",
    amcId:"",
    technician:"",
    pickupPerson:"",
    dropPerson:"",
    amcAvailable:"",
    technicianName:"",
    technicianEmailId:"",
    technicianMobileNo:"",
    technicianEmergencyNo:"",
    technicianEmpId:"",
    technicianBranch:"",
    technicianRole:"",
    technicianProfile:"",
    technicianAadhar:"",
    technicianLicense:"",
    email:"",
    warrantyData: null

}

export const requestUserAction = createSlice({
  name: 'requestUser',
  initialState,
  reducers: {
    setCreateRequestData: (state, action) => {
      // console.log(action.payload);
      state[action.payload.key] = action.payload.value
    },
    clearCreateRequestData:(state)=>{
      state.user_id= null;
      state.serviceType= "";
      state.servicePackage= "";
      state.bike_id= "";
      state.bikeType= "";
      state.bikeName= "";
      state.bikeBrand= "";
      state.bikeModel="";
      state.bikeWeight="";
      state.bikeMileage="";
      state.mobile="";
      state.name= "";
      state.city= "";
      state.addressName= "";
      state.state= "";
      state.pincode= "";
      state.address_type= "";
      state.full_address= "";
      state.address_id= "";
      state.frame_number= "";
      state.branch= "";
      state.serviceRequired= "";
      state.date_time= "";
      state.offer= "";
      state.amount= "";
      state.member_on= "";
      state.slotDate="";
      state.slotTime="";
      state.packageType="";
      state.gearSystem="";
      state.selectedAddress="";
      state.amcId="";
      state.email="";
      state.warrantyData=null;
    }
  },
})

export const { setCreateRequestData,clearCreateRequestData } = requestUserAction.actions

export default requestUserAction.reducer